import { User as FirebaseAuthUser } from 'firebase/auth';
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

type FirebaseAuthState = {
  firebaseAuthIdToken: string | null;
  firebaseAuthUser: FirebaseAuthUser | null;
  setFirebaseAuthIdToken: (token: string | null) => void;
  setFirebaseAuthUser: (user: FirebaseAuthUser | null) => void;
};

export const useFirebaseAuthStore = create(
  subscribeWithSelector<FirebaseAuthState>((set) => ({
    firebaseAuthIdToken: null,
    firebaseAuthUser: null,
    setFirebaseAuthIdToken: (token) => set({ firebaseAuthIdToken: token }),
    setFirebaseAuthUser: (user) => set({ firebaseAuthUser: user }),
  }))
);
